import { useContext } from 'react';

import { LicenseModalContext } from 'context/licenseModal/licenseModalContext/LicenseModalContext';

export const useLicenseModal = () => {
  const context = useContext(LicenseModalContext);

  if (context === undefined) {
    throw new Error('LicenseModalContext is unavailable, make sure you are using LicenseModalContextController');
  }

  return context;
};
